export const imgIdFrom = src => {
    return src.replace('/', '').split('.')[0]
}
